import { render, staticRenderFns } from "./TabCustomerCloudSave.vue?vue&type=template&id=19159127&scoped=true&"
import script from "./TabCustomerCloudSave.vue?vue&type=script&lang=js&"
export * from "./TabCustomerCloudSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19159127",
  null
  
)

export default component.exports